<template>
  <div
    role="alert"
    class="message"
  >
    {{ message }}
  </div>
</template>

<script>
export default {
  name: "SettingsMessage",
  props: {
    message: {
      type: String,
      default: ""
    }
  }
};
</script>

<style scoped>
.message {
  @apply bg-brand-light text-brand border font-bold rounded-lg px-4 py-2 mb-2 text-sm;
  border-color: #c0c7ef;

  @screen md {
    @apply mb-3;
  }
}
</style>
